(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name smsManager.controller:SmsManagerCtrl
   *
   * @description
   *
   */
  angular
    .module('smsManager')
    .controller('SmsManagerCtrl', SmsManagerCtrl);

  function SmsManagerCtrl(CommonMasterData,StorageServices, SmsManagerService, MessageService, applicationConstants, EventManagerService, $window, $timeout,
		  $stateParams) {
    var vm = this;
    vm.ctrlName = 'SmsManagerCtrl';

    var heightSearchPanel = 70 + angular.element('.toolbar').height();
    var heightGridData = 70 + angular.element('.toolbar').height() + 47;
    var rowHeight = 50;

    vm.model = {
      searchPanelToggle : true,
      initialSearchDone : false,
      searchCriteria : {
        fromDate : moment().format("DD/MM/YYYY"),
        toDate : moment().add(1,'d').format("DD/MM/YYYY"),
        refreshStatus : false,
        crewBase : '',
        status : null,
        pageSize : Math.ceil(screen.height / rowHeight) * 3,
        startPosition : 1
      },
      masterList : {
        crewBaseList : [],
        statusList : [],
        canvasHeight : $window.innerHeight - heightGridData,
        canvasWidth : $window.innerWidth - 70,
        fromDateFormatInvalid : false,
        toDateFormatInvalid : false,
        fromDateAfterToDate : false
      },
      SMSList: {}
    };

    angular.element($window).bind('resize', function(){
      $timeout(function () {
        angular.element('.search-panel').css("max-height", $window.innerHeight - heightSearchPanel);
        vm.model.masterList.canvasHeight = $window.innerHeight - heightGridData;
        vm.model.masterList.canvasWidth = $window.innerWidth - 70;

      },0);
    });

    EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

    function loadSmsDataForCrew(){
    	var tabLocalData = StorageServices.getTabData('smsManager');
    	if (!!tabLocalData && !!tabLocalData.sms_manager_data_for_crew) {
    		vm.model.searchCriteria.fromDate = tabLocalData.sms_manager_data_for_crew.fromDate;
    		vm.model.searchCriteria.toDate = tabLocalData.sms_manager_data_for_crew.toDate;
    		vm.model.searchCriteria.crewProfileId = tabLocalData.sms_manager_data_for_crew.crewProfileId;
    		vm.model.searchCriteria.startPosition = 1;

    		SmsManagerService.setSmsManagerSearchRequest(vm.model.searchCriteria);
    		getMessages();
        vm.model.searchCriteria.crewProfileId = null;
    	}
    }


    // to hide and show search panel
    vm.clickOnSearch = function() {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.submitSearch = function(searchParams) {
      if(isValidSearchParams()) {
        document.querySelector('.elastic_div').scrollTop = 0;
        vm.model.searchCriteria = searchParams;
        vm.model.searchCriteria.startPosition = 1;

        SmsManagerService.setSmsManagerSearchRequest(vm.model.searchCriteria);

        getMessages();
      }
    };

    vm.changeSearchField = function(searchParams, flag) {
      if (flag === 'fromDate') {
        setDateValidationFlags();
        if (vm.model.searchCriteria.fromDate) {
          var moEnd = moment(vm.model.searchCriteria.fromDate, applicationConstants.SETTINGS.DATE_FORMAT).endOf("month");
          vm.model.searchCriteria.toDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
        }
      }
    };

    // load grid data
    function getMessages() {
      vm.model.SMSList = {};

      SmsManagerService.searchMessages(function(responseData) {
        vm.model.SMSList = responseData;
        vm.model.SMSList.dtoList = SmsManagerService.getFormattedMessageList(responseData.dtoList);
        vm.model.searchPanelToggle = false;
        vm.model.initialSearchDone = true;
      }, function(error) {
        MessageService.error(error);
      });
    }

    function isValidSearchParams() {
      setDateValidationFlags();
      // if date invalid
      if(!isFromDateBeforeToDate()) {
        vm.model.masterList.fromDateAfterToDate = true;
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

      if (vm.model.masterList.toDateFormatInvalid || vm.model.masterList.fromDateFormatInvalid || vm.model.masterList.fromDateAfterToDate) {
        return false;
      } else {
        return true;
      }
    }

    function setDateValidationFlags() {
      // if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      // if to date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    // check from date and to date
    function isFromDateBeforeToDate() {
      return moment(vm.model.searchCriteria.fromDate,"DD/MM/YYYY").isBefore( moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY"))
        || moment(vm.model.searchCriteria.fromDate,"DD/MM/YYYY").isSame(moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY"));
    }

    // validate Date
    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function getNextSetOfRecords() {
      if (vm.model.SMSList && vm.model.SMSList.totalRecords
        && vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize < vm.model.SMSList.totalRecords) {
        vm.model.searchCriteria.startPosition = vm.model.searchCriteria.startPosition + vm.model.searchCriteria.pageSize;
        SmsManagerService.setSmsManagerSearchRequest(vm.model.searchCriteria);
        getDataForElasticSearch();
      } else {
        var lastPageStartPos = vm.model.SMSList.totalRecords - vm.model.searchCriteria.pageSize;
        if (vm.model.searchCriteria.startPosition < lastPageStartPos) {
          vm.model.searchCriteria.startPosition = lastPageStartPos;
          SmsManagerService.setSmsManagerSearchRequest(vm.model.searchCriteria);
          getDataForElasticSearch();
        }
      }
    }

    function getDataForElasticSearch() {
      SmsManagerService.searchMessages(function(newMessageData) {
        SmsManagerService.appendToGridMessageList(vm.model.SMSList.dtoList, SmsManagerService.getFormattedMessageList(newMessageData.dtoList));
      }, function(error) {
        MessageService.error(error);
      });
    }


    (function() {
      CommonMasterData.getCrewBaseList(
        function (baseTypes) {
          vm.model.masterList.crewBaseList = baseTypes;
        },
        function () {
          console.log('Crew Base type retrieval error');
        }
      );
      SmsManagerService.searchMessageStatus(function(msgStatusList) {
        vm.model.masterList.statusList = msgStatusList;
      }, function() {
        console.log('Message Status list retrieval error');
      });

      loadSmsDataForCrew();

    })();

  }
}());
